module.exports = __webpack_public_path__ + "static/media/sino.9c4151a1.svg";